import {
    FRONT_BEGIN,
    FRONT_SUCCESS,
    FRONT_FAILURE,
    CLEAR_FRONT
} from 'app/actions/FrontActions';

const initialState = {
    data: [],
    isLoading: false,
};

export default function FrontReducer(state = initialState, action) {
    switch (action.type) {
        case FRONT_BEGIN:
            return {
                ...state,
                isLoading: true
            }
        case FRONT_SUCCESS:
            let data = action.payload.data.Data
            
            return {
                ...state,
                data,
                isLoading: false,
            };
        case FRONT_FAILURE:
            return {
                ...state,
                isLoading: false
            }
        case CLEAR_FRONT:
            return {
                ...state,
                data: [],
                isLoading: false,
            }
        default:
            return state;
    }
};

export const getFront = state => {
    return state.data
}